import { MarkdownDisplay } from "@components/displays/MarkdownDisplay"
import { PropertiesPanel } from "@components/panels/PropertiesPanel"

import { useCompositeState } from "@hooks/use-composite-state"

import FormState from "@plugins/form/FormState"

export function StreamingDonePanel() {
    const formState = useCompositeState(FormState)

    if (formState.interaction.output_modality === "image") {
        return imageOutput(formState)
    }

    return textOutput(formState)
}

function textOutput(formState: FormState) {
    const result = formState.streamingText.value

    if (!result || result.trim().length === 0) {
        return
    }

    try {
        const formattedResult = JSON.parse(result)
        return <PropertiesPanel value={formattedResult} />
    } catch (error) {
        return <MarkdownDisplay content={result} />
    }
}

function imageOutput(formState: FormState) {
    let images = undefined

    try {
        images = JSON.parse(formState.streamingText.value).images
    } catch (error) {
        console.error("Error parsing images from streaming text:", error)
        return (
            <div className="flex flex-col items-center justify-center h-full text-center">
                <p>No images to display</p>
            </div>
        )
    }

    if (!images || images?.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center h-full text-center">
                <p>No images to display</p>
            </div>
        )
    }

    const useDoubleColumn = images.length > 1

    return (
        <div className={`grid gap-4 ${useDoubleColumn ? "grid-cols-1 md:grid-cols-2" : "grid-cols-1"}`}>
            {images.map((image: string) => (
                <div className="relative group overflow-hidden rounded-lg bg-gray-50">
                    <img src={`data:image/jpeg;base64, ${image}`} alt="Generated base64 image" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" loading="lazy" />

                    <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
            ))}
        </div>
    )
}
